module.exports = __webpack_public_path__ + "img/thumbnail_Cougar_f_normal.f3571e32.png";